import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CUSTOMERS_TABLE, CUSTOMERS_TABLE_LOOKUP } from 'shared/constants';
import { useService } from 'shared/providers';
import { CustomerLookup } from 'shared/types';

export function useEditCustomer(textEnqueueBar: string = 'edit') {
  const { customerService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const mutation = useMutation<void, Error, CustomerLookup>(
    customer => customerService.deleteCustomerPermanent(customer),
    {
      onSuccess: () => {
        enqueueSnackbar(`Customer was ${textEnqueueBar}d`, { variant: 'success' });
        queryClient.invalidateQueries(CUSTOMERS_TABLE);
        queryClient.invalidateQueries(CUSTOMERS_TABLE_LOOKUP);
      },
      onError: () => {
        enqueueSnackbar(`Could not ${textEnqueueBar} customer`, { variant: 'error' });
      },
    }
  );

  return mutation;
}
